import React from 'react'
import PrivacyPolicyModal from './details'
import PublicLayout from '../../layouts/publicLayout'

export default function Index() {
  return (
    <PublicLayout>
   {/* <ComingSoon title={'Privacy Policy'} /> */}
   <PrivacyPolicyModal />
    </PublicLayout>
  )
}